import { FlexBox } from "@/common/components/Box/FlexBox.tsx";
import styles from '@/features/Explorer/TabPanel.module.scss';
import clsx from "clsx";
import { useEffect, useState } from "react";

interface TabPanelProps {
  children?: React.ReactNode;
  isExplorer?: boolean;
  index: number;
  value: number;
  sx?: object;
  mountOnEnter?: boolean;
  unmountOnExit?: boolean;
}

export function TabPanel(props: TabPanelProps) {
  const {
    children,
    value,
    index,
    isExplorer,
    sx,
    mountOnEnter = false,
    unmountOnExit = false,
    ...other
  } = props;

  const isActive = value === index;
  const [hasMounted, setHasMounted] = useState(isActive);

  useEffect(() => {
    if (isActive && mountOnEnter && !hasMounted) {
      setHasMounted(true);
    }
  }, [
    isActive,
    mountOnEnter,
    hasMounted
  ]);

  const shouldRenderContent = () => {
    if (unmountOnExit) {
      return isActive;
    }
    if (mountOnEnter) {
      return isActive || hasMounted;
    }
    return true;
  };

  return (
    <FlexBox
      sx={sx}
      className={clsx(styles.TabPanel, {
        [styles.TabPanelExplorer]: isExplorer || false,
        [styles.active]: isActive,
      })}
      role="tabpanel"
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {shouldRenderContent() && children}
    </FlexBox>
  );
}
